import axios from 'axios';
import { attachAuthInterceptor } from './authToken';

const BASE_URL = (process.env.REACT_APP_CLUBHOUSE_API_URL || 'http://localhost:5000').replace(/\/+$/, '');

const apiClient = axios.create({ baseURL: `${BASE_URL}/api/account-verification` });
attachAuthInterceptor(apiClient);

export interface AccountVerificationStatus {
  isVerified: boolean;
  email?: string | null;
  verifiedAt?: string | null;
  canResend: boolean;
  isProfileConfirmed: boolean;
}

export interface ConfirmAccountEmailResult {
  isVerified: boolean;
  /** Short-lived handoff to exchange for a session, so the link's owner skips signing in again. */
  signInToken?: string | null;
  signInTokenExpiresAt?: string | null;
}

export const accountVerificationApi = {
  status: async (): Promise<AccountVerificationStatus> => {
    // Cache-bust so a freshly confirmed email is reflected immediately (mirrors the native
    // clients' force-refresh). Without a unique URL the browser/APIM can serve a stale
    // "not verified" response, so check-status never advances and confirm bounces back.
    const { data } = await apiClient.get<AccountVerificationStatus>('/status', {
      params: { _: Date.now() },
    });
    return data;
  },

  resend: async (email?: string | null): Promise<AccountVerificationStatus> => {
    const { data } = await apiClient.post<AccountVerificationStatus>('/resend', { email: email || null });
    return data;
  },

  confirm: async (token: string): Promise<ConfirmAccountEmailResult> => {
    const { data } = await apiClient.post<ConfirmAccountEmailResult>('/confirm', { token });
    return data;
  },
};